import { SectionWrapper } from '../../components/SectionWrapper';
import { studyFacts } from './kaiCoachContent';
import { KaiCoachEvidence } from './KaiCoachEvidence';
import { KaiCoachResultsChart } from './KaiCoachResultsChart';
import { KaiCoachSectionHead } from './KaiCoachSectionHead';

import styles from './KaiCoachResultsSection.module.css';

export function KaiCoachResultsSection() {
  return (
    <SectionWrapper
      aria-labelledby="kai-coach-results-title"
      background="white"
      data-testid="kai-coach-section-results"
      id="results"
    >
      <KaiCoachSectionHead
        id="kai-coach-results-title"
        kicker="What the first pilot found"
        lead="History 2C at UCLA, a six-week survey of medieval and early modern European religious history taught by Prof. Teofilo F. Ruiz, ran in 2025 without Kai Coach and in 2026 with it. Every written component of both years was analyzed. Grades weren’t used, because grading wasn’t blind to the coach."
        title={
          <>
            Same course. Same instructor. Same prompts. <em>One year with Kai Coach.</em>
          </>
        }
      />
      <ul aria-label="About the study" className={styles.facts}>
        {studyFacts.map((fact) => (
          <li className={styles.fact} key={fact.title}>
            <strong className={styles.factTitle}>{fact.title}</strong>
            <span className={styles.factDetail}>{fact.detail}</span>
          </li>
        ))}
      </ul>
      <KaiCoachResultsChart />
      <KaiCoachEvidence />
    </SectionWrapper>
  );
}
